import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const FormInput = ({ value, onChange, type, name, label, toggleIcon, formIcon, required }) => {
    return (
        <div className="form-input-container">
            <input
                type={type}
                name={name}
                id=""
                className="form-input"
                required={required}
                onChange={(e) => onChange(e)}
                value={value}
            />
            <label htmlFor="email" className="form-input-label">
                {label}
            </label>
            {formIcon && (
                <div
                    className="icon-button"
                    onClick={(e) => {
                        e.preventDefault();
                        toggleIcon(e);
                    }}
                >
                    <FontAwesomeIcon icon={formIcon} />
                </div>
            )}
        </div>
    )
}